(()=>{
 const badge=document.querySelector('.yi2c-offer-tab');
 const header=badge?.closest('.yi2c-site-header');
 if(!badge||!header)return;
 if(window.top!==window.self||document.querySelector('.sm-app,[data-yi2c-builder]')){badge.remove();return;}
 const compact=window.matchMedia('(max-width:1180px)');
 const footers=[...document.querySelectorAll('.yi2c-footer,footer,[role="contentinfo"]')].filter(el=>!el.closest('main,article'));
 let pending=false,lastHeight=0;
 const update=()=>{
  pending=false;
  const height=Math.ceil(header.getBoundingClientRect().height);
  if(height!==lastHeight){lastHeight=height;document.documentElement.style.setProperty('--yi2c-offer-header-height',height+'px');}
  if(compact.matches){badge.style.visibility='visible';return;}
  const r=badge.getBoundingClientRect();
  const blocked=footers.some(el=>{
   const b=el.getBoundingClientRect(),s=getComputedStyle(el);
   return b.width>0&&b.height>0&&s.display!=='none'&&s.visibility!=='hidden'&&b.top<r.bottom+6&&b.bottom>r.top-6&&b.left<r.right+6&&b.right>r.left-6;
  });
  badge.style.visibility=blocked?'hidden':'visible';
 };
 const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(update);}};
 document.addEventListener('scroll',schedule,{capture:true,passive:true});
 window.addEventListener('resize',schedule,{passive:true});
 window.addEventListener('load',schedule);
 window.addEventListener('pageshow',schedule);
 compact.addEventListener('change',schedule);
 if('ResizeObserver' in window){const observer=new ResizeObserver(schedule);observer.observe(header);observer.observe(document.body);}
 update();
})();
